import React, { FunctionComponent, memo, ReactNode } from 'react'

import { Link as RouterLink } from 'react-router-dom'

import { LinkWrapper } from './styled-link'

interface Props {
  to: string
  externalLink?: boolean
  children: ReactNode
  textProps?: object
  underline?: boolean
}

const Link: FunctionComponent<Props> = ({ to, externalLink, children, textProps, underline }) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation()
  }

  return (
    <LinkWrapper
      as={externalLink ? 'a' : RouterLink}
      target={externalLink ? '_blank' : undefined}
      $underline={underline}
      title={externalLink ? to : undefined}
      onClick={handleClick}
      {...{
        [externalLink ? 'href' : 'to']: to,
      }}
      {...textProps}
    >
      {children}
    </LinkWrapper>
  )
}

export default memo(Link)
